"use client";

import { CosmosButton, CosmosButtonProps } from "@cosmos/web-react";
import classnames from "classnames/bind";
import styles from "./ButtonPcs.module.css";

const cx = classnames.bind(styles);

export const ButtonPcs = ({
  className,
  customColor,
  ...props
}: CosmosButtonProps & {
  customColor?: string;
}) => {
  return (
    <CosmosButton
      className={cx("button", className)}
      data-custom-color={customColor}
      {...props}
    ></CosmosButton>
  );
};
